var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenGaurd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 59,
    viewBox: "0 0 56 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8130_31829)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8130_31829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4854 10.7909V26.4362C51.4854 40.6845 41.8095 53.1084 27.9885 56.6069C14.1905 53.1199 4.51465 40.6845 4.51465 26.4362V10.7909C15.3798 9.56693 21.534 5.43333 28 0.606934C34.466 5.43333 40.6202 9.56693 51.4854 10.7909Z",
    fill: "#ABC724"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 52.6069C16.7375 49.0319 9 38.5819 9 26.6319V15.1569C16.9125 13.4319 22.725 10.2444 28 6.60693C33.3875 10.3444 39.0875 13.4694 47 15.1694V26.6444C47 38.5819 39.2625 49.0319 28 52.6069Z",
    fill: "#B9D435"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8130_31829",
    x: 2.51465,
    y: 0.606934,
    width: 50.9707,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8130_31829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8130_31829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8130_31829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 58,
    fill: "white",
    transform: "translate(0 0.606934)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenGaurd);
export default __webpack_public_path__ + "static/media/screenGaurd.580f9698e40ebaf94480e4d0effe5b6c.svg";
export { ForwardRef as ReactComponent };